export default {
	getInvoicesCheckingUpdateOrganization(state) {
		return state.InvoicesCheckingUpdate;
	},

	getInvoicesCheckingUpdateTotal(state) {
		return state.InvoicesCheckingUpdateTotal;
	},

	getInvoicesCheckingUpdateSupplier(state) {
		return state.InvoicesCheckingUpdate;
	}
};
